var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBold = function SvgBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 11,
    viewBox: "296 610 10 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007faf",
    fillRule: "evenodd",
    d: "M301.848 621c2.048 0 3.104-1.28 3.104-2.896 0-1.328-.896-2.432-2.048-2.608 1.008-.208 1.84-1.12 1.84-2.448 0-1.424-1.04-2.72-3.072-2.72h-5.616V621zm-.672-6.432h-2.848v-2.24h2.848c.768 0 1.248.464 1.248 1.12 0 .688-.48 1.12-1.248 1.12m.096 4.432h-2.944v-2.432h2.944c.88 0 1.36.544 1.36 1.216 0 .768-.512 1.216-1.36 1.216"
  })));
};
export default SvgBold;